export default () => {
  return `
  <div class="recently-viewed-products-item swiper-slide">
    <a href="<%= window.Shopify.routes.root %>products/<%= products[index].handle %>">
      <div class="recently-viewed-products__image">
        <img loading="lazy" alt="<%= products[index].title %>" src="<%= products[index].featured_image.replace('.jpg', '_220x340@2x.jpg') %>" onError="this.src = '${window.theme.collections.placeholder}';" />

        <div class="recently-viewed-products__shop">SHOP NOW</div>
      </div>

      <p class="recently-viewed-products__name"><%= products[index].title %></p>
      <p class="recently-viewed-products__price">
        <%
        var product_from = '';
        if (products[index].raw_price_max > products[index].raw_price_min) {
          product_from = products[index].price_min;
        } 
        
        if (product_from === '') { %>
          <% if (products[index].raw_compare_at_price > products[index].raw_price) { %>
            <span class="visually-hidden">Regular price</span>
            <s class="price__compare-at"><%= products[index].compare_at_price %></s>
            <span class="price__sales"><%= products[index].price %></span>
          <% } else { %>
            <span class="price__regular"><%= products[index].price %></span>
          <% } %>
        <% } else { %>
          <span class="price__regular">From <%= product_from %></span>
        <% } %>
      </p>
    </a>
  </div>`;
};
